/* Store hours in Brisbane time (UTC+10, no DST). Shared by gg-click-collect and gg-visit-us.
   Hours are seven "HH:MM-HH:MM" strings, Sun..Sat; blank = closed. All times are minutes since midnight. */
(function (root) {
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const toMin = (s) => {
    const [h, m = '0'] = s.trim().split(':');
    return parseInt(h, 10) * 60 + parseInt(m, 10);
  };

  // ['10:00-17:00', '', ...] -> [[600, 1020], null, ...]; anything unparseable counts as closed.
  const parse = (days) => days.map((d) => {
    const parts = String(d || '').split('-');
    if (parts.length !== 2) return null;
    const t = parts.map(toMin);
    return t.every((n) => n >= 0) && t[1] > t[0] ? t : null;
  });

  // 600 -> "10am", 990 -> "4:30pm"
  const fmt = (min) => {
    const h = Math.floor(min / 60) % 24;
    const m = Math.round(min % 60);
    return ((h % 12) || 12) + (m ? ':' + String(m).padStart(2, '0') : '') + (h >= 12 ? 'pm' : 'am');
  };

  // 65 -> "1 hr 5 min", 45 -> "45 min"
  const duration = (mins) => (mins >= 60 ? Math.floor(mins / 60) + ' hr ' + (mins % 60) + ' min' : mins + ' min');

  const fill = (tpl, vars) => String(tpl || '').replace(/\{(\w+)\}/g, (all, k) => (k in vars ? vars[k] : all));

  function compute(hours, cutoffMin, nowMs) {
    const b = new Date(nowMs + 600 * 60000); // Brisbane wall clock, read with getUTC*
    const day = b.getUTCDay();
    const now = b.getUTCHours() * 60 + b.getUTCMinutes() + b.getUTCSeconds() / 60;
    const today = hours[day];
    const open = !!today && now >= today[0] && now < today[1];
    const cutoff = today ? today[1] - cutoffMin : 0;
    const sameDay = open && now < cutoff;
    const minutesLeft = sameDay ? Math.max(1, Math.floor(cutoff - now)) : 0;

    let offset = -1;
    if (today && now < today[0]) offset = 0;
    else for (let i = 1; i <= 7 && offset < 0; i++) if (hours[(day + i) % 7]) offset = i;
    const next = offset < 0 ? null : hours[(day + offset) % 7];

    return {
      open,
      sameDay,
      minutesLeft,
      todayIndex: day,
      key: open + '|' + sameDay,
      vars: {
        open: today ? fmt(today[0]) : '',
        close: today ? fmt(today[1]) : '',
        cutoff: today ? fmt(cutoff) : '',
        time_left: duration(minutesLeft),
        next_open: next ? fmt(next[0]) : '',
        next_day: offset === 0 ? 'today' : offset === 1 ? 'tomorrow' : offset > 1 ? DAYS[(day + offset) % 7] : '',
      },
    };
  }

  /* Calls render(state) now and every 30s. el carries data-hours (JSON array, Sun..Sat) and data-cutoff.
     render may return a sentence; it is written to el's [data-hours-announce] (aria-live) only when
     open/same-day changes, so ticks are silent. */
  function watch(el, render) {
    let days = [];
    try { days = JSON.parse(el.dataset.hours || '[]'); } catch (e) { /* bad JSON: treat as closed */ }
    const hours = parse(Array.from({ length: 7 }, (_, i) => days[i]));
    const cutoff = parseInt(el.dataset.cutoff, 10);
    const live = el.querySelector('[data-hours-announce]');
    let last = null;
    const tick = () => {
      const state = compute(hours, isNaN(cutoff) ? 60 : cutoff, Date.now());
      const said = render(state);
      if (live && last !== null && last !== state.key && said) live.textContent = said;
      last = state.key;
    };
    tick();
    return setInterval(tick, 30000);
  }

  const api = { parse, fmt, duration, fill, compute, watch };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.GgStoreHours = api;
})(typeof window !== 'undefined' ? window : this);
